import flatpickr from "flatpickr";

$(document).ready(function () {
    const $form = $('.js-addPostingForm');
    const $startDate = $('.js-startDate');
    const $endDate = $('.js-endDate');
    const $postingsList = $('.js-postingsList');
    const $userEmail = $('.js-userEmail');

    initDatepickers();

    if ($form.length && $postingsList.length) {
        init();
    }

    function initDatepickers() {
        const startDate = flatpickr($startDate, {
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd-m-Y',
            allowInput: true,
            onChange: function(sel, date) {
                endDate.set("minDate", date);
            }
        });

        const endDate = flatpickr($endDate, {
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd-m-Y',
            allowInput: true,
            onChange: function(sel, date) {
                startDate.set("maxDate", date);
            }
        });
    };

    const dateFormatter = (dateString) => {
        var date = new Date(dateString);
        var day = String(date.getDate()).padStart(2, '0');
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var year = date.getFullYear();
        
        return day + '.' + month + '.' + year;
    }

    const validFields = () => {
        if ($startDate.val() === '' || $endDate.val() === '') {
            $form.addClass('has-errors');
            return false;
        } else {
            $form.removeClass('has-errors');
            return true;
        }
    };

    const submitForm = (data) => {
        $form.addClass('is-loading');

        $.ajax({
            url: '/api/user/AddPosting',
            type: 'post',
            data,
            success: function (id) {
                loadPostings('append', id);
                $form.removeClass('is-loading');
            },
            error: function (err) {
                console.error("Error submitting posting - ", err)

                $form.addClass('has-errors');
                $form.removeClass('is-loading');
            }
        });
    };

    $form.submit(function(e){
        e.preventDefault();

        if(!validFields()) {
            return;
        }

        const data = $(this).serialize();

        submitForm(data);
    });

    const postingHtmlBuilder = (posting) => {
        return `<li class="postings-list-item">
                    <span class="postings-list-city">${posting.City}</span>
                    <div>
                        <span>${dateFormatter(posting.StartDate)}</span> - 
                        <span>${dateFormatter(posting.EndDate)}</span>
                        <button class="btn btn-alt postings-list-delete js-deletePostingButton" title="Exclude posting" data-posting-id="${posting.Id.toString()}"><i class="fa fa-times"></i></button>
                    </div>
                </li>`;
    };

    $(document).on('click', '.js-deletePostingButton', function() {
        deletePosting($(this).attr('data-posting-id'));
    });

    function deletePosting(postingId) {
        if (!postingId) {
            return;
        }

        $.ajax({
            url: '/api/user/RemovePosting',
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify(postingId),
            success: function () {
                loadPostings('replace');
            },
            error: function (err) {
                console.error("Error removing posting - ", err)
            }
        });
    }

    function loadPostings(method, id = '') {
        if (!$userEmail) {
            return;
        }

        $postingsList.addClass('is-loading');

        $.ajax({
            url: `/api/user/GetPostings?email=${$userEmail.val()}`,
            type: 'get',
            success: function (postings) {
                if (!postings) {
                    return;
                }

                if (method === 'replace') {
                    $postingsList.empty();

                    $.each(postings, function(index, posting){
                        $postingsList.append(postingHtmlBuilder(posting));
                    });
                } else if (method === 'append') {
                    const postingToAdd = postings.find((posting) => {
                        return posting.Id === id;
                    });

                    if (postingToAdd) {
                        $postingsList.append(postingHtmlBuilder(postingToAdd));
                    }
                }

                $postingsList.removeClass('is-loading');
            },
            error: function (err) {
                console.error("Error loading postings - ", err)
                $postingsList.removeClass('is-loading');
            }
        });
    }

    function init() {
        loadPostings('replace');
    }
});